var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-card', {
    staticClass: "shadow-sm"
  }, [_c('b-card-body', [_c('b-card-title', {
    staticClass: "mb-2 pl-6 pr-6 pt-6"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "currency-dollar",
      "variant": "primary"
    }
  }), _c('b-dropdown', {
    attrs: {
      "variant": "link",
      "toggle-class": "p-0 text-secondary font-weight-bold dashboard-title-dropdown",
      "menu-class": "dashboard-title-menu",
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.indicadorSelecionadoLabel))]), _c('b-icon', {
          staticClass: "ml-2",
          attrs: {
            "icon": "chevron-down"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    attrs: {
      "active": _vm.indicadorSelecionado === 'margem'
    },
    on: {
      "click": function click($event) {
        _vm.indicadorSelecionado = 'margem';
      }
    }
  }, [_vm._v(" Margem de lucro ")]), _c('b-dropdown-item', {
    attrs: {
      "active": _vm.indicadorSelecionado === 'lucro'
    },
    on: {
      "click": function click($event) {
        _vm.indicadorSelecionado = 'lucro';
      }
    }
  }, [_vm._v(" Lucro ")])], 1)], 1), _c('FiltroPeriodo', {
    staticClass: "mt-4",
    attrs: {
      "value": _vm.periodo,
      "default-label": "Hoje",
      "auto-apply-on-mount": !_vm.ignoreInitialApply
    },
    on: {
      "apply": _vm.onApplyPeriodo
    }
  })], 1), _c('div', {
    staticClass: "pl-6 pb-4"
  }, [_vm.loading ? _c('div', {
    staticClass: "display-4"
  }, [_c('b-skeleton', {
    attrs: {
      "width": "40%",
      "height": "36px"
    }
  })], 1) : _c('div', [_c('h2', {
    staticClass: "display-4 text-primary mb-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.indicadorSelecionado === "margem" ? _vm.formatPercent(_vm.margemNumber) : _vm.formatCurrency(_vm.lucroNumber)) + " ")])])])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };